// App.tsx
import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { SessionProvider } from "./SessionContext";
import { useTranslation } from "react-i18next";
import "./i18n";

import Dashboard from "./pages/Dashboard";
import ManageAccount from "./pages/ManageAccount";
import Preferences from "./pages/Preferences";
import AfterLogin from "./pages/AfterLogin";
import OrganisationPortal from "./pages/OrganisationPortal";
import InvitePage from "./pages/InvitePage";
import LoginOnlyCallback from "./pages/LoginOnlyCallback";
import MyArea from "./pages/MyArea"; // Import the new My Area screen

const isAuthenticated = () => {
  return !!localStorage.getItem("token");
};

const ProtectedRoute = ({ element }: { element: React.ReactNode }) => {
  return isAuthenticated() ? <>{element}</> : <Navigate to="/invite" />;
};

const App: React.FC = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language") || "en";
    i18n.changeLanguage(savedLanguage);
  }, [i18n]);

  return (
    <SessionProvider>
      <Routes>
        <Route path="/" element={<ProtectedRoute element={<Dashboard />} />} />
        <Route path="/organisation/:organisationID/:NCJPRecordID" element={<ProtectedRoute element={<OrganisationPortal />} />} />
        <Route path="/account" element={<ProtectedRoute element={<ManageAccount />} />} />
        <Route path="/preferences" element={<ProtectedRoute element={<Preferences />} />} />
        <Route path="/my-area" element={<ProtectedRoute element={<MyArea />} />} />
        <Route path="/invite" element={<InvitePage />} />
        <Route path="/after-login" element={<AfterLogin />} />
        <Route path="/login-only-callback" element={<LoginOnlyCallback />} />
      </Routes>
    </SessionProvider>
  );
};

export default App;
